import { render, staticRenderFns } from "./AddAnotherItems.vue?vue&type=template&id=1e174910"
import script from "./AddAnotherItems.vue?vue&type=script&lang=js"
export * from "./AddAnotherItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports